/**
 * Tag “X pessoas vendo agora” na PDP — autônomo (mobile, tablet, desktop).
 * - Número base único por visitante (sessionStorage) e por produto.
 * - Alterna o valor ao longo do tempo para parecer ao vivo.
 */
(function () {
  const STORAGE_PREFIX = 'md-pdp-viewers-base-';

  function hashSeed(str) {
    let h = 0;
    for (let i = 0; i < str.length; i += 1) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h);
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function getVisitorBase(productId, min, max) {
    const key = STORAGE_PREFIX + productId;
    try {
      const stored = sessionStorage.getItem(key);
      if (stored) {
        const n = parseInt(stored, 10);
        if (!Number.isNaN(n) && n >= min && n <= max) return n;
      }
    } catch (e) {
      /* sessionStorage indisponível */
    }

    const span = max - min + 1;
    const productOffset = hashSeed(String(productId)) % span;
    const visitorJitter = Math.floor(Math.random() * Math.min(15, span));
    const base = min + ((productOffset + visitorJitter) % span);

    try {
      sessionStorage.setItem(key, String(base));
    } catch (e) {
      /* ignore */
    }

    return base;
  }

  function pickLiveCount(base, min, max) {
    const delta = Math.floor(Math.random() * 9) - 4;
    return clamp(base + delta, min, max);
  }

  function initViewers(root) {
    if (!(root instanceof HTMLElement)) return;

    const wrap = root.querySelector('[data-md-viewers]');
    if (!wrap || wrap.dataset.mdViewersInit === 'true') return;
    const countEl = wrap.querySelector('[data-md-viewers-count]');
    if (!countEl) return;

    wrap.dataset.mdViewersInit = 'true';

    const min = Number(root.dataset.viewersMin || 18);
    const max = Number(root.dataset.viewersMax || 98);
    const safeMin = Math.min(min, max);
    const safeMax = Math.max(min, max);
    const productId = root.dataset.productId || '0';

    const base = getVisitorBase(productId, safeMin, safeMax);

    const update = () => {
      const count = pickLiveCount(base, safeMin, safeMax);
      countEl.classList.remove('is-blink');
      void countEl.offsetWidth;
      countEl.textContent = String(count);
      countEl.classList.add('is-blink');
    };

    update();

    const tick = () => {
      update();
      const next = 6000 + Math.floor(Math.random() * 9000);
      window.setTimeout(tick, next);
    };

    window.setTimeout(tick, 6000 + Math.floor(Math.random() * 4000));
  }

  function initAll() {
    document.querySelectorAll('[data-md-pdp]').forEach(initViewers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
